export default ".overview-float-right{float:right;margin-right:8px !important}::ng-deep .overview-float-right{margin-right:10px !important}";